"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _withContainer = require("./withContainer");

var _withContainer2 = _interopRequireDefault(_withContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgProfileSecondary = function SvgProfileSecondary(props) {
    return _react2.default.createElement(
        "svg",
        Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 32" }, props),
        _react2.default.createElement(
            "g",
            { transform: "translate(2 4)", fill: "currentColor", fillRule: "nonzero" },
            _react2.default.createElement("path", { d: "M25.87 15.46A6.78 6.78 0 0024.6 14a5.71 5.71 0 00-1.84-1.05 6.8 6.8 0 00-2.34-.39c-.47.047-.92.22-1.3.5l-1.3.76a7.41 7.41 0 01-1.65.66 7 7 0 01-4 0 7.41 7.41 0 01-1.65-.66L9.19 13a2.7 2.7 0 00-1.31-.5 6.7 6.7 0 00-2.33.39A5.71 5.71 0 003.71 14a7 7 0 00-1.28 1.51 9 9 0 00-.84 1.74 12.17 12.17 0 00-.49 1.85 15.18 15.18 0 00-.26 1.85c0 .54-.07 1.12-.07 1.72a4.69 4.69 0 001.61 3.72 6.08 6.08 0 004.12 1.32h4.94a1 1 0 001.05-1 .9.9 0 00-.28-.65 1.1 1.1 0 00-.77-.32H6.5a4 4 0 01-2.68-.84 2.9 2.9 0 01-1-2.32c0-.547.02-1.077.06-1.59.043-.548.12-1.092.23-1.63a11.4 11.4 0 01.43-1.61 7.47 7.47 0 01.66-1.37 5 5 0 01.9-1.07 3.71 3.71 0 011.16-.66 5 5 0 011-.22c.257-.025.516.03.74.16l1.31.77a9.58 9.58 0 002.13.87 9.27 9.27 0 005.32 0 9.39 9.39 0 002.13-.87l1.32-.77a1.26 1.26 0 01.74-.16 4.34 4.34 0 011 .23c.425.14.818.361 1.16.65.35.31.654.671.9 1.07.271.432.496.891.67 1.37a14 14 0 01.43 1.61 1 1 0 00.94.73 1.33 1.33 0 001-.37.83.83 0 00.15-.7 11.58 11.58 0 00-.5-1.86 8.7 8.7 0 00-.83-1.7z" }),
            _react2.default.createElement("path", { d: "M14 .45a6.08 6.08 0 106.08 6.08A6.09 6.09 0 0014 .45zm0 10.18a4.1 4.1 0 114.1-4.1 4.11 4.11 0 01-4.1 4.1z" }),
            _react2.default.createElement("circle", { cx: 15.87, cy: 26.67, r: 1.33 })
        )
    );
};

exports.default = (0, _withContainer2.default)(SvgProfileSecondary);